// extracted by mini-css-extract-plugin
export default {"footer":"Signup_footer__9L8z9","terms":"Signup_terms__+gAwE","error":"Signup_error__kXist","recaptcha":"Signup_recaptcha__oZTey","errorMessage":"Signup_errorMessage__J61wc"};